import type { CSSProperties } from 'react'

/**
 * Public shop UI tokens derived from `ShopWebsiteConfig.primary_color`.
 * Uses color-mix where supported for a cohesive “same family” look.
 */
export function shopDisplayOnlyButtonStyle(primary: string): CSSProperties {
  return {
    backgroundColor: `color-mix(in srgb, ${primary} 32%, rgb(100 116 139))`,
    color: '#ffffff',
  }
}

/**
 * Primary catalog CTA (Add to cart / Choose options) — same hue as brand primary,
 * lightened so the full-width button does not overpower title and price.
 */
export function shopPrimaryActionButtonStyle(primary: string): CSSProperties {
  return {
    backgroundColor: `color-mix(in srgb, ${primary} 62%, white)`,
    color: '#ffffff',
  }
}

/** Outline / secondary action — distinct from solid primary “Add to cart”. */
export function shopRequestBuyButtonStyle(primary: string): CSSProperties {
  return {
    color: primary,
    borderColor: primary,
    backgroundColor: '#ffffff',
  }
}
